export default "__VITE_ASSET__DuV27jpO__"